import { applyItemQueryParameterDefaults } from '@mimir/common/api/defaultQueryParameters';
import type { AdditionalParams } from '@mimir/common/util/apiClient';

/**
 * Applies some default query parameters for APIs that return item payloads.
 * These parameters should always be present when the requests originate from our own client.
 */
export const injectDefaultQueryParamsForItemApis = (params: AdditionalParams = {}) => {
  params.queryParams = applyItemQueryParameterDefaults(params.queryParams ?? {});
  return params;
};
